import { FaWhatsapp } from "react-icons/fa";
import CourseSection from "../components/CourseSection";
import DaycareSection from "../components/DaycareSection";
import FacilitiesComponent from "../components/FacilitiesComponent";
import Footer from "../components/Footer";
import FounderSection from "../components/FounderSection";
import HeroSection from "../components/HeroSection";
import Navbar from "../components/Navbar";
import PhotoGallery from "../components/PhotoGallary";
import SuperBar from "../components/SuperBar";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import GoogleAnalytics from "../components/GoogleAnalytics";

function Home() {
  return (
    <div>
      <SEO />
      <StructuredData />
      <GoogleAnalytics />
      <SuperBar />
      <Navbar />
      <div id="home">
        <HeroSection />
      </div>
      <div id="courses" className="pt-20">
        <CourseSection />
      </div>
      <div id="daycare" className="pt-20">
        <DaycareSection />
      </div>
      <div id="gallery" className="pt-20">
        <PhotoGallery />
      </div>
      <div id="facilities" className="pt-20">
        <FacilitiesComponent />
      </div>
      <div id="founder" className="pt-20">
        <FounderSection />
      </div>
      <Footer />

      {/* ✅ WhatsApp Floating Icon Button */}
      <a
        href="https://wa.me/919834387679?text=Hi%2C%20I%20have%20an%20enquiry%20for%20admission"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          cursor: "pointer",
        }}
      >
        <FaWhatsapp size={32} />
      </a>
    </div>
  );
}

export default Home;
